var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col relative"},[_c('GmapMap',{directives:[{name:"show",rawName:"v-show",value:(_vm.state),expression:"state"}],ref:"gmap",staticClass:"h-full",attrs:{"center":_vm.center,"zoom":_vm.zoom,"clickable":true,"options":_vm.options},on:{"center_changed":_vm.handleMapChange,"idle":_vm.handleMapChange}},[(_vm.state)?_c('GmapCluster',{attrs:{"zoom-on-click":true,"max-zoom":_vm.zoomOnSelect,"styles":[
                {
                    textColor: '#003F6B',
                    textSize: '14',
                    fontWeight: '700',
                    fontFamily: 'Gotham, Helvetica, sans-serif',
                    url: '/dist/images/geosearch/cluster-small.png',
                    height: 80,
                    width: 80,
                    anchorText: [-2, 0]
                },
                {
                    textColor: '#003F6B',
                    textSize: '16',
                    fontWeight: '700',
                    fontFamily: 'Gotham, Helvetica, sans-serif',
                    url: '/dist/images/geosearch/cluster-large.png',
                    height: 96,
                    width: 96,
                    anchorText: [-2, 0]
                }
            ]}},_vm._l((_vm.state.items),function(item){return _c('GmapMarker',{key:item.id,attrs:{"position":item._geoloc,"clickable":true,"icon":_vm.getMarkerIcon(item)},on:{"click":function($event){return _vm.$emit('set-active-marker', item)}}})}),1):_vm._e(),_vm._v(" "),(_vm.activeMarker && !_vm.isMobile)?_c('GmapInfoWindow',{attrs:{"options":_vm.infoWindowOptions,"position":_vm.activeMarker._geoloc}}):_vm._e()],1),_vm._v(" "),(_vm.activeMarker && _vm.isMobile)?[_c('MapViewProvider',{attrs:{"item":_vm.activeMarker},on:{"close":function($event){return _vm.$emit('set-active-marker', undefined)}}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }